import { IonRouterOutlet, createAnimation } from '@ionic/react';
import { Redirect, Route } from 'react-router-dom';
import { RouteNames } from '../../models/routes.model';
import SignIn from './signIn/SignIn';
import { Wrapper } from './Public.styles';

export interface IComponentProps { }

const animationBuilder = (baseEl: any, opts: any) => {
  const enteringAnimation = createAnimation().addElement(opts.enteringEl).fromTo('opacity', 0, 1).duration(250);
  const leavingAnimation = createAnimation().addElement(opts.leavingEl).fromTo('opacity', 1, 0).duration(250);
  const animation = createAnimation().addAnimation(enteringAnimation).addAnimation(leavingAnimation);
  return animation;
};

const Public: React.FC<IComponentProps> = function () {
  return (
    <Wrapper>
      <IonRouterOutlet id="main" animation={animationBuilder}>
        <Route path={RouteNames.signin} component={SignIn} />
        <Redirect exact from="/" to={RouteNames.signin} />
        <Route render={() => <Redirect to="/" />} />
      </IonRouterOutlet>
    </Wrapper>
  );
};

export default Public;
